import { type QueryObserverResult } from '@tanstack/react-query'
import React, { createContext, useContext, useMemo, useState } from 'react'

import { useGetQuotingProspectsId } from 'utils/web_api'
import { type QuotingProspect } from 'utils/web_api.schemas'

export const ProspectContext = createContext<{
  prospect?: QuotingProspect
  isLoading: boolean,
  error?: unknown,
  setId: (id: string) => void
  refetch: ReturnType<typeof useGetQuotingProspectsId>['refetch']
}>({
      isLoading: false,
      setId: () => {},
      refetch: async () => ({ data: null, isLoading: false, isError: false, error: null } as QueryObserverResult<unknown, unknown>),
    })

export function useProspect () {
  return useContext(ProspectContext)
}

export function ProspectProvider ({ id, children }: { id?: string, children: React.ReactNode }) {
  const [prospectId, setId] = useState<string>(id ?? '')
  const { data, isLoading, error, refetch } = useGetQuotingProspectsId(
    prospectId,
    { query: { enabled: !!id } })

  const value = useMemo(() => ({
    prospect: data,
    isLoading,
    error,
    setId,
    refetch
  }), [id, data, refetch])

  return (
    <ProspectContext.Provider value={value}>
      {children}
    </ProspectContext.Provider>
  )
}
